import cs from 'timeago.js/esm/lang/cs'
import { register } from 'timeago.js/esm/register'
import { format } from 'timeago.js/esm/format'

register('cs', cs)

export function timeAgo(date) {
  return format(date, 'cs')
}
